import script from "./HeaderItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderItems.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderItems.vue?vue&type=style&index=0&id=42541966&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Arco\\Documents\\Git\\unifix\\unifix-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42541966"]])

export default __exports__